var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataPrivacyIconRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M12.7 8.037V5.733c0-.622-.16-1.207-.48-1.756-.32-.548-.755-.983-1.303-1.303-.549-.32-1.134-.48-1.756-.48-.622 0-1.207.16-1.755.48-.549.32-.983.755-1.303 1.303-.32.549-.48 1.134-.48 1.756v2.304h7.076zm3.318 0c.622 0 1.161.219 1.619.658.457.439.685.969.685 1.59v11.466c0 .622-.228 1.152-.685 1.59-.458.44-.997.659-1.619.659H2.304c-.622 0-1.161-.22-1.618-.658-.457-.44-.686-.97-.686-1.591V10.286c0-.622.229-1.152.686-1.591.457-.439.996-.658 1.618-.658h1.125V5.733c0-1.043.256-2.003.768-2.88C4.709 1.975 5.403 1.28 6.28.768 7.16.256 8.12 0 9.161 0c1.042 0 2.002.256 2.88.768.878.512 1.573 1.207 2.085 2.085.512.877.768 1.837.768 2.88v2.304h1.124z",
    transform: "translate(-117 -129) translate(86 99) translate(28 30) translate(3.324 .674)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.176 17.21c.68 0 1.427.098 2.24.296.922.23 1.668.538 2.239.922.68.45 1.021.955 1.021 1.515v1.383h-11v-1.383c0-.56.34-1.065 1.021-1.515.57-.384 1.317-.692 2.24-.922.812-.198 1.558-.297 2.239-.297zm0-1.384c-.494 0-.95-.124-1.367-.37-.417-.248-.749-.58-.996-.997-.247-.417-.37-.873-.37-1.367s.123-.955.37-1.383c.247-.428.58-.765.996-1.012.417-.247.873-.371 1.367-.371s.95.124 1.367.37c.417.248.749.585.996 1.013.247.428.37.89.37 1.383 0 .494-.123.95-.37 1.367-.247.417-.58.75-.996.996-.417.247-.873.371-1.367.371z",
    transform: "translate(-117 -129) translate(86 99) translate(28 30) translate(3.324 .674)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117 -129) translate(86 99) translate(28 30) translate(3.324 .674) translate(11.676 15.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#EB3C39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.5 3.21L6.71 6 9.5 8.79 8.79 9.5 6 6.71 3.21 9.5 2.5 8.79 5.29 6 2.5 3.21 3.21 2.5 6 5.29 8.79 2.5z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacyIconRed);
export default __webpack_public_path__ + "static/media/data_privacy_icon_red.b33579305cd620a5c48c0900e694cf8d.svg";
export { ForwardRef as ReactComponent };